<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="off-the-map">
<h1>Off the Map</h1>
<p style="text-indent:0em">Although there was a fully functioning door</p>
<p style="text-indent:0em">I had to crawl out through the window</p>
<p style="text-indent:0em">If I was to be anywhere close to my departure rendezvous</p>
<p style="text-indent:0em">Strong arms hauled me through because I was in danger of falling on my face</p>
<p style="text-indent:0em">Because I went out face first and my feet were the last of me to leave the room</p>
<p style="text-indent:0em">The feet being the most critical on the long march they had devised</p>
<p style="text-indent:0em">My face part of my critical faculty best left at the back of the march</p>
<p style="text-indent:0em">Instead of the little yard I had tendered was a sodden field with oxen in it</p>
<p style="text-indent:0em">Weather was tied up with strings of rain</p>
<p style="text-indent:0em">There was a little hill we had to wind around</p>
<p style="text-indent:0em">And there was no beyond that could be seen</p>
<p style="text-indent:0em">It was akin to riding off the map</p>
<p style="text-indent:0em">A map shown to the horse who seemed to understand it</p>
<p style="text-indent:0em">The riders of which I was one having no idea</p>
<p style="text-indent:0em">Heads down hats down we went at standing pace</p>
<p style="text-indent:0em">It was difficult to know if we</p>
<p style="text-indent:0em">Were entering a trance state or leaving a trance state</p>
<p style="text-indent:0em">If I had holy exited by the door and not the window</p>
<p style="text-indent:0em">I may still be in that world of house and garden</p>
<p style="text-indent:0em">Which may not exist in any universe but me</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?2fdea6a4